<template>
  <div class="container-fluid login">
    <div class="row">
      <div class="col-12 col-md-12 col-lg-5 d-flex align-items-center flex-column info">
        <div class="logo">
          <a :href="lpUrl" class="ico-iouu" target="_blank" title="IOUU"></a>
        </div>
        <div class="row justify-content-center d-flex align-items-center">
          <div class="col-12 col-lg-10 d-flex flex-column align-items-center">
          <h1>Crie sua conta</h1>
            <p>
              Não se preocupe. Você não está assumindo nenhum compromisso neste momento.
              <br/>Suas informações serão usadas apenas para analisarmos o seu perfil
            </p>
            <p>
              Através da plataforma, você poderá enviar todos os documentos solicitados, fazer investimentos e solicitar empréstimo.
            </p>
          </div>
        </div>
      </div>
      <div class="col-12 col-md-12 col-lg-7 d-flex flex-column form" >
        <header class="align-self-center align-self-md-end">
          Já tem uma conta?
          <router-link to="login" class="btn btn-outline-primary">Entrar</router-link>
        </header>
        <div class="row justify-content-center d-flex align-items-center">
          <div class="col-12 col-md-8 col-lg-5 text-center">
            <h2>Criar uma conta</h2>
            <form id="form-criarContaLead" @submit.prevent="signUp">
              <div class="form-group text-left">
                <label for="name">Nome</label>
                <input id="Nome" name="name" type="text" class="form-control form-control-lg" v-model="name" autofocus>
              </div>
              <div class="form-group text-left">
                <label for="email">Endereço de email</label>
                <input type="email" class="form-control form-control-lg" id="Email" v-model="email" disabled>
                <div class="validacao">
                  <i hidden id="IconeInvalido" class="invalido fas fa-exclamation-circle"></i>
                  <i hidden id="IconeValido"   class="valido fas fa-check"></i>
                </div>

              </div>
              <div class="form-group text-left">
                <label for="password">Senha</label>
                <password-field v-model="password"/>
              </div>

              <div class="form-check text-left d-flex justify-content-center">
                <div class="checkboxContainer">
                  <input class="form-check-input" type="checkbox" @click="validateCampos" id="terms">
                  <span class="checkmark"></span>
                </div>
                <label class="form-check-label p-0">
                  Eu "CONCORDO" com os <a :href="lpUrl+'/termos-e-condicoes/'" target="_blank">Termos e condições</a> e <a :href="lpUrl+'/politica-de-privacidade/'" target="_blank">Política de privacidade</a> da IOUU.
                </label>
              </div>
                <button class="btn btn-lg btn-primary" :disabled="!enabled || !validate">Continuar</button>
            </form>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  	@import "../assets/styles/iouu/variables";
	@import "../assets/styles/iouu/mixins";

  .form-check-label {
    &.p-0 {
      & {
        padding-left: 0;
      }
    }
  }

  .aviso {
	  h2 {
		  padding-bottom: 30px;

		  @include xs {
			  @include font-size(25px);
			  padding-bottom: 40px;
		  }
	  }
	  .btn-primary {
		border-color: #888;
		background: #fff;
		@include font-size(18px);
		margin: 0 10px;
		text-transform: uppercase;
		line-height: 55px;
		padding: 0px 55px;
		font-weight: bold;


		@include xs {
			@include font-size(15px);
			line-height: 40px;
			width: 80%;
			margin-bottom: 10px;
		}

		span {
			color: #999;
		}

		&:hover {
			border-color: $c3;
			background: $c3;

			span {
				color: #fff;
			}
		}
	  }
  }
  // CHECKBOX - CUSTOM
	.checkboxContainer {
		&{
		  display: block;
		  position: relative;
		  cursor: pointer;
		  -webkit-user-select: none;
		  -moz-user-select: none;
		  -ms-user-select: none;
			user-select: none;
			width: 25px;
			height: 25px;
			margin-right: 10px;
    }

		&:hover {
		  input ~ .checkmark {
			background-color: #ccc;
		  }
		}

		input {
		  position: absolute !important;
		  opacity: 0;
		  width: 25px;
		  height: 25px;
		  cursor: pointer;
			left: 0;
      margin-left: 0;
      top: -4px;

		  &:checked ~ .checkmark {
			background-color: #41D3BF;
		  }
		}

		.checkmark {
		  position: absolute;
		  top: -4px;
		  left: 0;
		  height: 25px;
		  width: 25px;
		  background-color: #eee;
		  border-radius: 6px;
		  cursor: pointer;
		  pointer-events: none;

		  &::after {
			content: "";
			position: absolute;
			display: none;
			left: 9px;
			top: 5px;
			width: 8px;
			height: 13px;
			border: solid white;
			border-width: 0 3px 3px 0;
			-webkit-transform: rotate(45deg);
			-ms-transform: rotate(45deg);
			transform: rotate(45deg);
		  }

		}

		input:checked ~ .checkmark:after {
		  display: block;
		}
	}
	// END CHECKBOX - CUSTOM


  .login {
    .info {
      background:url(/static/assets/images/bg-login.jpg) top center no-repeat, linear-gradient(to bottom right, $c3, $c2 85%);
      background-size: cover;
      // background-blend-mode: multiply;
      text-align: center;
      color: #fff;
    }
  }
</style>

<script>
/* eslint-disable */
import ApiClient from '../utils/api-client'
import ArrayHelper from '@/utils/array-helper'
import PasswordField from '@/components/PasswordField'

export default {
  data() {
    return {
      lpUrl:process.env.LP_URL,
      name: '',
      email: '',
      password: '',
      CodConvite: '',
      id: '',
      enabled: false,
      validate: false,
      visivel:false,
    }
  },
  components: {
    PasswordField
  },
  methods: {
    signUp() {
      this.$store.dispatch('signup_lead', {name: this.name, email: this.email, password: this.password, tipo: "TOM"})
      .then(() => {
	      console.log("teste")
	      if(this.id !== ""){
		this.$router.push(`/informacoes-adicionais/emprestimo-coletivo/${this.id}`)
	      } else {
	       this.$router.push("/");
	      }	      
      })
      .catch(error => {
        const errorMessages = error.response.data.errors.map(error => error.detail)
        this.$Notify.error(ArrayHelper.toSentence(errorMessages))
      })

    },
    validateCampos() {
      this.enabled = document.getElementById("terms").checked

      if(this.enabled) {
        if(this.name !== "" && this.email !== "" && this.password !== "") {
          this.validate = true
        } else {
          this.enabled= false;
          document.getElementById("terms").checked = false

          if(this.name === "" && this.email === "" && this.password || this.name === "" && this.email === ""
          || this.email === "" && this.password === "" || this.name === "" && this.password === "") {
            this.$Notify.error("Preencha todos os campos!!!")
          } else {
            if(this.name === "") {
              this.$Notify.error("Preencha o seu nome!")
            }

            if(this.email === "") {
              this.$Notify.error("Preencha o seu Email!")
            }

            if(this.password === "") {
              this.$Notify.error("Preencha a sua senha!")
            }
          }
        }
      }
    },
    setCampos() {
      if(this.$route.query.email) {
        this.email = this.$route.query.email
      }

      if(this.$route.query.loansId) {
	      this.id = this.$route.query.loansId
      }

      if(this.$route.query.name) {
        this.name = this.$route.query.name
        document.getElementById("Nome").setAttribute("disabled", true)
      }
    },

    //tagueamento GA
    taggingGA() {
      this.$ga.page({
        page: '/criar-conta-lead/',
        title: 'Criar conta lead',
      })
    },
  },
  mounted(){
    this.setCampos()
  },
  async created() {
    //tagueamento GA
    await this.taggingGA();
  }
}
</script>



// WEBPACK FOOTER //
// src/views/CriarContaLead.vue